export function checkEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
}

export function checkNumber(number) {
  if (number === null || number === '') {
    return false;
  }
  const numberRegex = /^[0-9]+$/;
  return numberRegex.test(number);
}

export function checkText(text) {
  if (text === null || text === '') {
    return false;
  }
  const textRegex = /^[a-zA-Z0-9 ,./?:;"'[\]{}+_)(*&^%$#@!\s-]+$/;
  return textRegex.test(text);
}
export function checkPhone(phone) {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
}

export function checkDate(date) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return dateRegex.test(date);
}

export const getValidationError = (input, type) => {
  const value = typeof input === 'string' ? input.trim() : String(input).trim();
  if (value === null || value === '') {
    return 'This field is required.';
  }
  if (value !== value.trim()) {
    return 'Extra spaces are not allowed.';
  }
  switch (type) {
    case 'email':
      return checkEmail(value) ? '' : 'Invalid email address.';
    case 'number':
      return checkNumber(value) ? '' : 'Invalid number.';
    case 'text':
      return checkText(value) ? '' : 'Invalid text.';
    case 'phone':
      return checkPhone(value) ? '' : 'Invalid phone number.';
    case 'date':
      return checkDate(value) ? '' : 'Invalid date.';
    default:
      return '';
  }
};
